export * from './indicators.shared.module';
export * from './indicator.shared.component';
